module.exports = __webpack_public_path__ + "static/media/exportUser.231fd05a.svg";